import _request from './request.js'

const pendingContractLineRequests = new Map();

function getContractLineRequestKey(form = {}) {
	return Object.keys(form)
		.sort()
		.map((key) => `${key}:${String(form[key])}`)
		.join('|');
}

export default {
	tradeCurrencyList() {
		return _request.request("api/currency/getTradeCurrencyList");
	},
	contractCurrencyList() {
		return _request.request("api/currency/getContractCurrencyList");
	},
	matchesCurrency() {
		return _request.request("api/currency/getMatchesCurrency");
	},
	getCurrencyInfo(id, cid) {
		return _request.request("api/currency/currencyinfo", {
			id: id,
			cm_id: cid
		}, "POST");
	},
	getRechargeLog(param) {
		return _request.request("api/currency/rechargeLog", param);
	},
	getWithLog(param){
		return _request.request("api/account/withRecord",param,"POST");
	},
	contractLine(form){
		const requestKey = getContractLineRequestKey(form);
		const pendingRequest = pendingContractLineRequests.get(requestKey);

		if (pendingRequest) {
			return pendingRequest;
		}

		const request = _request.request("api/currency/contractLine",form,"POST");
		pendingContractLineRequests.set(requestKey, request);
		request.then(
			() => pendingContractLineRequests.delete(requestKey),
			() => pendingContractLineRequests.delete(requestKey)
		);

		return request;
	},
	
	// 期权交易相关API
	futuresCurrency() {
		return _request.request("api/futures/currency");
	},
	futuresDep(param) {
		return _request.request("api/futures/dep", param, "POST");
	},
	futuresSubmit(param) {
		return _request.request("api/futures/submit", param, "POST");
	},
	futuresUlist(param) {
		return _request.request("api/futures/ulist", param, "POST");
	},
	futuresHistory(param) {
		return _request.request("api/futures/history", param, "POST");
	}
}
